"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpCheckbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DpCheckbox_styled_1 = require("./DpCheckbox.styled");
/**
 * DpCheckbox
 * @property {boolean}     checked         - Boolean value of checkbox's checked state
 * @property {boolean}     indeterminate   - Boolean value of checkbox's indeterminate state
 * @property {string}      inputSmSize     - Boolean value of checkbox's input size
 * @property {boolean}     disabled        - Flag to indicate if the Dropdown is disabled
 * @property {Function}    changeHandler   - Callback function fired when value of checkbox changes
 */
var DpCheckbox = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, indeterminate = _a.indeterminate, _c = _a.inputSmSize, inputSmSize = _c === void 0 ? true : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, changeHandler = _a.changeHandler, _e = _a.ariaLabelledbyId, ariaLabelledbyId = _e === void 0 ? '' : _e, ariaLabel = _a.ariaLabel, className = _a.className, onKeyDown = _a.onKeyDown, tabIndex = _a.tabIndex;
    var _f = (0, react_1.useState)(checked), inputChecked = _f[0], setInputChecked = _f[1];
    var _g = (0, react_1.useState)(indeterminate), inputIndeterminate = _g[0], setInputIndeterminate = _g[1];
    (0, react_1.useEffect)(function () {
        setInputChecked(checked);
        setInputIndeterminate(indeterminate);
    }, [checked, indeterminate]);
    var changeState = function () { return function (e) {
        setInputChecked(!inputChecked);
        if (inputIndeterminate) {
            setInputIndeterminate(false);
            setInputChecked(false);
        }
        if (changeHandler) {
            changeHandler(!inputChecked);
        }
    }; };
    return ((0, jsx_runtime_1.jsxs)(DpCheckbox_styled_1.StyledCheckbox, { inputSmSize: inputSmSize, className: className, onKeyDown: onKeyDown, tabIndex: tabIndex, id: "checkbox", children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", className: "checkbox", "aria-checked": inputChecked, "aria-labelledby": ariaLabelledbyId || 'checkbox', "aria-label": ariaLabelledbyId ? null : ariaLabel, ref: function (input) {
                    if (input) {
                        input.checked = inputChecked;
                        input.indeterminate = inputIndeterminate;
                        input.disabled = disabled;
                    }
                }, disabled: disabled, onChange: changeState(), tabIndex: -1 }), (0, jsx_runtime_1.jsx)("span", { className: "checkmark", "data-testid": "checkMark" })] }));
};
exports.DpCheckbox = DpCheckbox;
exports.default = exports.DpCheckbox;
